import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=2811f914"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports